import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

export const LabelLinkWrapperExt = styled.a`
  text-decoration: none;
  display: flex;
  align-items: center;
  ${props => props.color && css`
    color: ${props.color};
  `};
  flex-direction: ${props => (props.rotate ? 'row-reverse' : 'row')};
  
`;

export const LabelLinkWrapperInt = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  margin: 0em 0.2em 0.2em 0em;
  ${props => props.color && css`
     color: ${props.color};
  `};
  flex-direction: ${props => (props.rotate ? 'row-reverse' : 'row')};
`;

export const LinkWrapper = styled.div`
  margin: ${props => (props.isForm ? '0 0.3em 0' : '')};
`;



// WEBPACK FOOTER //
// ./src/components/shared/LabelLink/styles.js